import { cn } from "lib/utils";
import { ChevronDown } from "lucide-react";
import { useState } from "react";
import { lpConfig } from "routes/LandingPage/lpConfig";
import { useFadeIn } from "routes/LandingPage/useFadeIn";

/**
 * ランディングページのFAQセクション
 * よくあるご質問をアコーディオン形式で表示する
 * @return {JSX.Element} FAQセクションコンポーネント
 */
export function LpFaq() {
  const { ref, isVisible } = useFadeIn();
  const [activeIndex, setActiveIndex] = useState<number | null>(null);

  /**
   * FAQアイテムのトグル処理
   * @param {number} index - トグル対象のインデックス
   * @return {void}
   */
  const handleToggle = (index: number): void => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section id="faq" className="py-24 lg:py-32 bg-white">
      <div
        ref={ref}
        className={cn(
          "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 lp-fade-in-up",
          isVisible && "lp-visible",
        )}
      >
        <div className="text-center mb-16">
          <span className="text-xs font-bold tracking-widest text-[#ff8d00] uppercase mb-4 block">
            {lpConfig.faq.sectionLabel}
          </span>
          <h2 className="text-4xl font-bold text-[#0F1649]">
            {lpConfig.faq.heading}
          </h2>
        </div>

        <div className="max-w-3xl mx-auto">
          {lpConfig.faq.items.map((item, i) => (
            <div key={item.question} className="border-b border-gray-200">
              <button
                type="button"
                className="w-full py-6 flex items-center justify-between text-left text-lg font-bold text-[#0F1649] hover:text-[#1667CF] transition-colors"
                onClick={() => handleToggle(i)}
              >
                <span>{item.question}</span>
                <ChevronDown
                  className={cn(
                    "w-5 h-5 flex-shrink-0 ml-4 transition-transform duration-300",
                    activeIndex === i && "rotate-180",
                  )}
                />
              </button>
              <div
                className="overflow-hidden"
                style={{
                  maxHeight: activeIndex === i ? "500px" : "0",
                  opacity: activeIndex === i ? 1 : 0,
                  transition: "max-height 0.3s ease, opacity 0.3s ease",
                }}
              >
                <p className="text-gray-600 pb-6 leading-relaxed">
                  {item.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
